import { CatalogApp } from '@/webapi/use-widget-catalog-api';
import { useFeatureBit } from '@/features/account-context';
import { FeatureBit } from '@/webapi/use-auth-api';

export function useAppsList() {
  const shouldShowTestWidgets = useFeatureBit(
    FeatureBit.SHOW_TEST_WIDGETS,
    false,
  );

  const filterTestsApp = (app: CatalogApp) => {
    if (shouldShowTestWidgets) {
      return true;
    }
    return ![`tests`].includes(app.id);
  };

  return {
    filterTestsApp,
    shouldShowTestWidgets,
  };
}
